//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {required, minLength, email} from "vuelidate/lib/validators";
import {UserAuthMixin, UserMixin, CmsMetaMixin} from "~/node_modules/sitis-nuxt/lib/mixins";
import UserProfile from "~/mixin/user-profile.js";
import Breadcrumbs from "~/components/page/PageBreadcrumbs";
import sessionTokenGenerate from "~/helpers/sessionTokenGenerate";
import AuthTg from "~/components/additional-auth-methods/AuthTg.vue";

export default {
  name: "Authorization",

  components: {
    AuthTg,
    Breadcrumbs
  },

  data: function () {
    return {
      form: {
        username: "",
        password: "",
        token: "",
      },

      blockErrorMessage: '',

      isSubmiting: false,
      isNeedTwoFactor: false,

      countErrorsTwoFactor: 0,
    };
  },

  validations: function () {
    let form = {
      username: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
    };

    if (this.isNeedTwoFactor) {
      form.token = {
        required,
      };
    }

    return {
      form,
    };
  },

  mixins: [UserMixin, UserProfile, UserAuthMixin, CmsMetaMixin],

  layout: "custom-layout",

  computed: {
    getBreadcrumbs() {
      const breadcrumbs = [
        {path: "/", title: this.$t("breadcrumbs.homePage")},
        {path: this.$route.path, title: this.$t('authorization.title')},
      ];
      return breadcrumbs;
    },

    isRecaptchaTest() {
      return Boolean(Number.parseFloat(this.$store?.state?.appState?.config?.useReCaptchaForAuth || 0))
    },

    isUseGoBack: function () {
      if (!process.client) {
        return false
      }
      return Boolean(window.history?.length >= 2)
      // return Boolean(
      //   window.history?.length > 2 &&
      //   this.$route?.query?.goback
      // )
    },
    isShowAuthTg: function () {
      return this.$route?.query?.authTg === "1"
    }
  },

  methods: {
    onAuthorization: async function () {
      // Анализ корректности заполнения формы
      this.$v.$touch();

      // Если есть ошибки по форме заполнения
      if (this.$v.$invalid) {
        return null;
      }

      let newForm = {...this.form};

      if (this.isRecaptchaTest) {
        newForm['g-recaptcha-response'] = await this.$recaptcha.getResponse().then((res) => {
          return res
        }).catch(() => {
          return ""
        });
        await this.$recaptcha.reset();
      }

      this.isSubmiting = true;

      // Запрос к API для авторизации пользователя
      const {data} = await this.$api.agent.transport
        .post("users/login", newForm)
        .catch((err) => {
          return {
            data: {
              errorMessage:
                err.response?.data?.[0] || "Ошибка сервера",
            },
          };
        });

      if (data.errorMessage?.field === 'block') {
        this.isSubmiting = false;
        this.blockErrorMessage = data.errorMessage?.message;
        return;
      }

      // Если метод вернул ошибку
      if (data?.errorMessage?.message) {
        this.isSubmiting = false;

        this.$toast.error(data?.errorMessage.message);

        return null;
      }

      // Если у пользователя фключена двух факторная авторизация
      if (data.need_two_factor) {
        this.isSubmiting = false;
        this.isNeedTwoFactor = true;

        this.$toast.success(data.message);

        return false;
      }

      // Если пользователь авторизован успешно

      // Запись токена пользователя P.S. MIXIN
      this.setToken({
        authToken: data.token,
      });

      // Запись токена в хранилище
      this.$cookies.set("authToken", data.token, {
        path: "/",
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
      });

      // Получение данные пользователя P.S. MIXIN
      await this.getUser();
      this.isSubmiting = true;

      // Редирект в личный кабинет
      if (this.isUseGoBack) {
        this.$router.back();
      }
      this.$router.replace(this.localePath("/profile"));
    },
    onLoginTwoFactor: async function () {
      // Анализ корректности заполнения формы
      this.$v.$touch();

      // Если есть ошибки по форме заполнения
      if (this.$v.$invalid) {
        return null;
      }

      this.isSubmiting = true;

      const data = await this.$api.agent.transport
        .post(`/users/login/two-factor`, {
          token: this.form.token,
        })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          return {error: err.response};
        });

      if (data.error) {
        this.isSubmiting = false;
        const errorMessage =
          data.error?.data?.[0]?.message ||
          data.error?.data?.message ||
          "Ошибка сервера";
        this.$toast.error(errorMessage);

        if (this.countErrorsTwoFactor >= 3) {
          this.countErrorsTwoFactor = 0;
          this.isNeedTwoFactor = false;
          this.isSubmiting = false;

          return;
        }

        this.countErrorsTwoFactor = this.countErrorsTwoFactor + 1;

        return;
      }

      // Запись токена пользователя P.S. MIXIN
      this.setToken({
        authToken: data.token,
      });

      // Запись токена в хранилище
      this.$cookies.set("authToken", data.token, {
        path: "/",
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
      });

      // Получение данные пользователя P.S. MIXIN
      await this.getUser();

      this.isSubmiting = true;

      // Редирект в личный кабинет
      await this.$router.replace(this.localePath("/profile"));
    },
  },
};
